const navigationToggle = document.querySelector(".navigation-toggle");

if (navigationToggle) {
   const body = document.body;
   const navigationMobile = document.querySelector(".navigation-mobile");

   const menuToggleOpen = () => {
      setTimeout(() => {
         // body.style.overflow = "hidden";
         navigationToggle.setAttribute("aria-expanded", "true");
         navigationMobile.classList.add("show");
      }, 1);
   };

   const menuToggleClose = () => {
      setTimeout(() => {
         // body.removeAttribute("style");
         navigationToggle.setAttribute("aria-expanded", "false");
         navigationMobile.classList.remove("show");
      }, 1);
   };


   navigationToggle.addEventListener('click', (e) => {
      if (navigationToggle.getAttribute("aria-expanded") == "false") {
         menuToggleOpen();
      } else {
         menuToggleClose();
      }
   });
}